'use es6';

import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ProgressBar from './ProgressBar';
import Score from './Score';
import UIUtil from '../util/UIUtil';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class BreakdownScore extends Component {
  constructor(...args) {
    super(...args);
    this.titleClicked = () => {
      UIUtil.scrollTo(`#${this.props.page}`);
    };
  }
  render() {
    const {
      score,
      overallScore,
      page
    } = this.props;
    const scorePercentage = score / overallScore * 100;
    return /*#__PURE__*/_jsxs(Score, {
      scorePercentage: scorePercentage,
      onClick: this.titleClicked,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "score-title",
        children: [/*#__PURE__*/_jsx("div", {
          className: "auditTitle",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `results.${page}.title`
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "score",
          children: [score, /*#__PURE__*/_jsxs("span", {
            className: "overall",
            children: ["/", overallScore]
          })]
        })]
      }), /*#__PURE__*/_jsx(ProgressBar, {
        scorePercentage: scorePercentage
      })]
    });
  }
}